import { Component, OnInit } from '@angular/core';
import { Prefrence } from './model/interfaces';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-pierhippdemo',
  templateUrl: './pierhippdemo.component.html',
  styleUrls: ['./pierhippdemo.component.css']
})
export class PIERHIPPDEMOComponent implements OnInit {
  preference: Prefrence | null = null;
  email: string | undefined = '';
  tollfreeNo: string | undefined | null = '';
  faxNo: string | undefined | null = '';
  errorMessageIntialData: string = '';
  mailingAddress: string = '';
  dropingAddress: string ='';
  emailTo: string = '';
  logo: any;
  applicationPdf: any;
  mailingOffice: string='';
  mailingAddressLine: string='';
  mailingAddressLine2: string='';
  mailingCityStateZip: string='';
  empInsuranceDataPdf:any;
  documentChecklistPdf: any;
  authorizationFormPdf: any;
  faqFormPdf: any;
  consentForm: any;
  benefitMonth?: string;
  eobYear?:number;
  benefitYear?:number;
  thirtyPlusDate?: string | null;


  constructor(
    private dataService: DataService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.logo = 'app/module/pierhippdemo/assets/img/DEMO_LOGO.png';
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;

        this.faxNo = ValidationService.formatPhoneNumber(
          this.preference.preferenceValues?.['FAX_NUM']
        );
        this.applicationPdf = this.preference.paperApplication;
        this.empInsuranceDataPdf = this.preference.empInsuranceData;
        this.documentChecklistPdf = this.preference.documentChecklist;
        this.authorizationFormPdf = this.preference.authorizationForm;
        this.faqFormPdf = this.preference.faqForm;
        this.consentForm = this.preference.consentForm;
        this.eobYear = this.preference.eobYear;
        this.benefitYear = this.preference.benefitYear;
        this.benefitMonth = this.preference.benefitMonth;
        
        this.tollfreeNo = ValidationService.formatPhoneNumber(this.preference.preferenceValues?.['TOLL_FREE_NUM']);

        this.email = this.preference.preferenceValues?.['EMAIL_ID'];
        this.emailTo = 'mailto:' + this.email;
        this.mailingAddress =
          '' +
          this.preference.preferenceValues?.['STATE_PROGRAM'] +
          ', ' +
          this.preference.preferenceValues?.['ADDRESS1_TXT'] +         
          ', ' +
          this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['ZIP_CODE'];

          this.mailingOffice = '' + this.preference.preferenceValues?.['STATE_PROGRAM'];
          this.mailingAddressLine = '' + this.preference.preferenceValues?.['ADDRESS1_TXT'];
          this.mailingAddressLine2 = '' + this.preference.preferenceValues?.['ADDRESS2_TXT'];
          this.mailingCityStateZip = '' + this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' + this.preference.preferenceValues?.['STATE_CD'] +
          ' ' + this.preference.preferenceValues?.['ZIP_CODE'];

        this.dropingAddress =
        '' +
          this.preference.preferenceValues?.['DROPOFF_OFFICE'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_CITY'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['DROPOFF_ZIPCD'];


      },
      error: (err: HttpErrorResponse) => {
        this.logger.logMsg(err.error);
        const msg = 'Unable to get the Preference details: ' + err.message;
        this.errorMessageIntialData = msg;
      },
    });
  }

  openPaperApplication(){
    let bytes = this.applicationPdf;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = 'PaperApplication.pdf';
    anchor.click();
  }

  

  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
}

